import { Wrench, ArrowRight } from "lucide-react";
import { useState } from "react";
import { Navbar, Footer } from "@/components/Chrome";
import { ProposalDialog } from "@/components/ProposalDialog";

export const QuoteLocked = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-spott-light">
      <Navbar />
      <div className="relative overflow-hidden bg-spott-blue py-16 grain">
        <div className="arc-deco -left-24 -bottom-32 h-80 w-80" />
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-spott-yellow">En actualización</p>
          <h1 className="mt-3 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            El cotizador está en actualización
          </h1>
          <p className="mt-2 max-w-xl text-sm font-light text-spott-mid">
            Estamos cargando el inventario y las tarifas reales de toda la red de retailers aliados.
            Mientras tanto, nuestro equipo diseña tu propuesta 360° sin costo.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-2xl px-5 py-16" data-testid="quote-locked">
        <div className="rounded-xl border border-spott-mid bg-white p-8">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-spott-yellow text-spott-blue">
            <Wrench size={18} />
          </span>
          <h2 className="mt-5 text-lg font-bold text-spott-blue">Tú pones el presupuesto. Spott diseña la estrategia.</h2>
          <p className="mt-2 text-sm text-gray-600">
            Cuéntanos tu objetivo y cuánto quieres invertir. Te enviamos una propuesta inicial que conecta
            retail y punto de venta, awareness y digital, a nivel nacional.
          </p>
          <button onClick={() => setOpen(true)} data-testid="locked-proposal-btn"
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-spott-yellow px-7 py-4 text-sm font-bold text-spott-blue transition-transform hover:scale-[1.03]">
            Quiero mi propuesta gratis
            <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
          </button>
          <p className="mt-3 text-xs text-gray-500">
            Sin compromiso. Déjanos tus datos, objetivo y presupuesto estimado.
          </p>
          <p className="mt-6 text-xs text-gray-400">
            ¿Eres del equipo Spott? Inicia sesión con tu cuenta interna para acceder al cotizador.
          </p>
        </div>
      </div>
      <ProposalDialog open={open} onOpenChange={setOpen} />
      <Footer />
    </div>
  );
};
